import axios from 'axios';
import _ from 'lodash'; // если у вас есть lodash, иначе напишем свой debounce

const classPrefix = 'search';
const dataPrefix = 'data-search';
const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    search();
}

export function search() {
    const $formEl    = $container.querySelector(`[${dataPrefix}-form]`);
    const $inputEl   = $formEl.querySelector(`[${dataPrefix}-form-input]`);
    const $formBody  = $container.querySelector(`[${dataPrefix}-form-body]`);

    const openTriggers  = [...document.querySelectorAll('[data-search-open]')];
    const closeTriggers = [...document.querySelectorAll('[data-search-close]')];

    init();
    bindSearch();

    function init() {
        initInputAnimation($formEl, $inputEl);

        openTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                $container.classList.toggle(`${classPrefix}--open`);
                $inputEl.focus();
            });
        });
        closeTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                $container.classList.remove(`${classPrefix}--open`);
            });
        });
        document.addEventListener('click', e => {
            if (!$container.contains(e.target) && !openTriggers.some(t => t.contains(e.target))) {
                $container.classList.remove(`${classPrefix}--open`);
            }
        });
    }

    function bindSearch() {
        // дебаунс, чтобы не спамить сервер
        const doSearch = _.debounce(async () => {
            const q = $inputEl.value.trim();
            if (q.length < 2) {
                render([]);
                return;
            }
            try {
                const { data } = await axios.get('/api/search', { params: { q } });
                render(data.results);
            } catch (err) {
                console.error('Search API error', err);
                render([]);
            }
        }, 300);

        $inputEl.addEventListener('input', () => {
            doSearch();
        });
    }

    function render(items) {
        $formBody.innerHTML = '';
        if (items.length === 0) {
            $formBody.innerHTML = '<div class="search__no-results">Нiчого не знайдено</div>';
        } else {
            // Разбиваем по типам
            const pages    = items.filter(i => i.type === 'page');
            const products = items.filter(i => i.type === 'product');

            // Контейнер с двумя колонками
            const cols = document.createElement('div');
            cols.className = `${classPrefix}__columns`;

            // Колонка «Страницы»
            const colPages = document.createElement('div');
            colPages.className = `${classPrefix}__column ${classPrefix}__column--pages`;
            // Заголовок
            const hPages = document.createElement('h4');
            hPages.textContent = 'Сторiнки';
            hPages.className = `${classPrefix}__heading`;
            colPages.appendChild(hPages);
            // Список
            if (pages.length) {
                const ulPages = document.createElement('ul');
                ulPages.className = `${classPrefix}__results`;
                pages.forEach(item => {
                    const li = document.createElement('li');
                    li.className = `${classPrefix}__result-item`;
                    li.innerHTML = `<a href="${item.url}">
                                    <span class="search__result-title">${item.title}</span>
                                </a>`;
                    ulPages.appendChild(li);
                });
                colPages.appendChild(ulPages);
            } else {
                const empty = document.createElement('div');
                empty.className = `${classPrefix}__empty`;
                empty.textContent = '—';
                colPages.appendChild(empty);
            }

            // Колонка «Товары»
            const colProd = document.createElement('div');
            colProd.className = `${classPrefix}__column ${classPrefix}__column--products`;
            const hProd = document.createElement('h4');
            hProd.textContent = 'Продукти';
            hProd.className = `${classPrefix}__heading`;
            colProd.appendChild(hProd);
            if (products.length) {
                const ul = document.createElement('ul');
                ul.className = `${classPrefix}__results`;
                products.forEach(item => {
                    const li = document.createElement('li');
                    li.className = `${classPrefix}__result-item`;
                    li.innerHTML = `
                    <a href="${item.url}">
                        ${item.image
                        ? `<img src="${item.image}" alt="${item.title}" class="${classPrefix}__thumbnail">`
                        : `<div class="${classPrefix}__thumbnail ${classPrefix}__thumbnail--empty"></div>`
                    }
                        <span class="search__result-title">${item.title}</span>
                    </a>
                `;
                    ul.appendChild(li);
                });
                colProd.appendChild(ul);
            } else {
                colProd.innerHTML += `<div class="${classPrefix}__empty">—</div>`;
            }

            cols.appendChild(colPages);
            cols.appendChild(colProd);
            $formBody.appendChild(cols);
        }

        // Показываем тело и активируем состояние
        $formBody.style.display = items.length ? 'block' : 'flex';
        $container.querySelector(`.${classPrefix}__form`).classList.add('active');
    }


    function initInputAnimation($formEl, $inputEl) {
        // $formEl — элемент с [data-input-form], $inputEl — input или textarea
        if (!$formEl || !$inputEl) return;

        // При загрузке, если уже есть value, ставим active
        if ($inputEl.value && $inputEl.value.trim()) {
            $formEl.classList.add('active');
        }

        $inputEl.addEventListener('focus', () => {
            $formEl.classList.add('active');
        });

        $inputEl.addEventListener('blur', () => {
            if (!$inputEl.value.trim()) {
                $formEl.classList.remove('active');
            }
        });

        // Если нужно, можно слушать input для динамических изменений
        $inputEl.addEventListener('input', () => {
            if ($inputEl.value.trim()) {
                $formEl.classList.add('active');
            }
        });
    }


}
